import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { CameraDiscoveryRequest } from 'types/camera_discovery_request';
import { useAPI } from 'hooks/api/useAPI';

export function useCreateCameraDiscoveryRequest({
  onSettled,
  onMutate,
  ...options
}: UseMutationOptions<
  CameraDiscoveryRequest,
  APIError,
  { gateway_id: string }
> = {}) {
  const { applicationID, client } = useAPI();

  return useMutation(async ({ gateway_id }) => {
    const { data } = await client.post(
      `/apps/${applicationID}/gateways/${gateway_id}/discovery_request`
    );

    return data;
  }, options);
}
